import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';

function DropdownActions(props) {
  const {
    cellInfo,
    getSelectionList,
    getGclDetailData,
    handleGoToCustomizeLetter,
    handleViewDetailsForInvoiceDetail,
    handleGoToContract,
    handleGoToManufacturer,
    handleGoToRebateProgram,
    handleGoToLetterTemplate,
  } = props;

  const [anchorEl, setAnchorEl] = React.useState();
  const [open, setOpen] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <SVGComponent iconName="Icon-export" />
      </IconButton>

      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        className="export_dropdown"
      >
        <MenuItem
          role="button"
          onClick={() => {
            handleClose();
            handleGoToCustomizeLetter(cellInfo?.data);
          }}
          disabled={!getGclDetailData?.mergeFieldFlag}
        >
          Customize Letter
        </MenuItem>
        <MenuItem
          role="button"
          onClick={() => {
            handleClose();
            handleViewDetailsForInvoiceDetail(cellInfo?.data);
          }}
          // disabled={!getGclDetailData?.mergeFieldFlag}
        >
          Go to Invoice
        </MenuItem>
        <MenuItem
          role="button"
          onClick={() => {
            handleClose();
            handleGoToContract(cellInfo?.data, getSelectionList);
          }}
          // disabled={!getGclDetailData?.mergeFieldFlag}
        >
          Go to Contract
        </MenuItem>
        <MenuItem
          role="button"
          onClick={() => {
            handleClose();
            handleGoToManufacturer(cellInfo?.data);
          }}
          // disabled={!getGclDetailData?.mergeFieldFlag}
        >
          Go to Manufacturer
        </MenuItem>
        <MenuItem
          role="button"
          onClick={() => {
            handleClose();
            handleGoToRebateProgram(cellInfo?.data, getSelectionList);
          }}
          // disabled={!getGclDetailData?.mergeFieldFlag}
        >
          Go to Rebate Program
        </MenuItem>
        <MenuItem
          role="button"
          onClick={() => {
            handleClose();
            handleGoToLetterTemplate(cellInfo?.data, getSelectionList);
          }}
          // disabled={!getGclDetailData?.mergeFieldFlag}
        >
          Go to Letter Template
        </MenuItem>
      </Menu>
    </>
  );
}

export default DropdownActions;
